export interface ILogger {
    debug: (message: string, payload?: object) => void;
    info: (message: string, payload?: object) => void;
    warning: (message: string, payload?: object) => void;
    error: (message: string, payload?: object) => void;
}

const loggers: ILogger[] = [];

export const addLogger = (logger: ILogger) => {
    loggers.push(logger);
};

const log: ILogger = {
    debug: (message: string, payload?: object) => {
        loggers.forEach((logger) => logger.debug(message, payload));
    },
    info: (message: string, payload?: object) => {
        loggers.forEach((logger) => logger.info(message, payload));
    },
    warning: (message: string, payload?: object) => {
        loggers.forEach((logger) => logger.debug(message, payload));
    },
    error: (message: string, payload?: object) => {
        loggers.forEach((logger) => logger.debug(message, payload));
    },
};

export default log;
